<ng-container *transloco="let t">
  <div class="gs">
    <div
      class="gs__field"
      [class.gs__field--focus]="abierto()"
      role="combobox"
      [attr.aria-expanded]="abierto()"
      aria-haspopup="listbox"
      aria-owns="gs-panel"
    >
      <span class="gs__icon" aria-hidden="true">
        <app-ui-icon name="search" [size]="18" />
      </span>

      <!--
        `data-lrp-search` es el ancla del atajo «/» (onDocumentKeydown).
        No quitarlo: sin el atributo, la tecla deja de enfocar el buscador.
      -->
      <input
        type="text"
        data-lrp-search
        class="gs__input"
        autocomplete="off"
        spellcheck="false"
        [attr.aria-label]="t('BUSQUEDA.PLACEHOLDER')"
        [placeholder]="t('BUSQUEDA.PLACEHOLDER')"
        [value]="query()"
        (input)="onQueryChange($any($event.target).value)"
        (focus)="onFocus()"
        (keydown)="onKeydown($event)"
      />
    </div>

    @if (abierto()) {
      <div class="gs__panel" id="gs-panel" role="listbox">
        <!-- ── Campo vacío o demasiado corto: historial ── -->
        @if (mostrarHistorial()) {
          @if (recientes.operaciones().length > 0) {
            <div class="gs__section">
              <div class="gs__section-head">
                <span class="gs__section-title">{{
                  t('BUSQUEDA.RECENTS.OPERATIONS')
                }}</span>
                <button
                  type="button"
                  class="gs__section-action"
                  (click)="limpiarHistorial($event)"
                >
                  {{ t('BUSQUEDA.RECENTS.CLEAR') }}
                </button>
              </div>

              @for (op of recientes.operaciones(); track keyOperacion(op)) {
                <button
                  type="button"
                  role="option"
                  class="gs__item"
                  [class.gs__item--active]="activeKey() === keyOperacion(op)"
                  [attr.aria-selected]="activeKey() === keyOperacion(op)"
                  (click)="onClickOperacion(op, $event)"
                  (auxclick)="onAuxClickOperacion(op, $event)"
                >
                  <span class="gs__item-icon">
                    <app-ui-icon [name]="ICONO_TIPO[op.tipo]" [size]="18" />
                  </span>
                  <span class="gs__item-body">
                    <span class="gs__item-title">{{ op.numero }}</span>
                  </span>
                  <span
                    class="gs__state"
                    [class.gs__state--closed]="!op.abierto"
                  >
                    {{
                      op.abierto
                        ? t('BUSQUEDA.STATE.OPEN')
                        : t('BUSQUEDA.STATE.CLOSED')
                    }}
                  </span>
                </button>
              }
            </div>
          }

          @if (recientes.consultas().length > 0) {
            <div class="gs__section">
              <div class="gs__section-head">
                <span class="gs__section-title">{{
                  t('BUSQUEDA.RECENTS.QUERIES')
                }}</span>
              </div>
              @for (c of recientes.consultas(); track keyConsulta(c)) {
                <button
                  type="button"
                  role="option"
                  class="gs__item"
                  [class.gs__item--active]="activeKey() === keyConsulta(c)"
                  [attr.aria-selected]="activeKey() === keyConsulta(c)"
                  (click)="activar({ kind: 'consulta', texto: c })"
                >
                  <span class="gs__item-icon">
                    <app-ui-icon name="history" [size]="18" />
                  </span>
                  <span class="gs__item-body">
                    <span class="gs__item-title gs__item-title--plain">{{
                      c
                    }}</span>
                  </span>
                </button>
              }
            </div>
          }

          @if (!recientes.hayHistorial()) {
            <p class="gs__hint">
              {{ t('BUSQUEDA.HINT', { min: MIN_CARACTERES }) }}
            </p>
          }
        } @else {
          <!-- ── Resultados ── -->
          @if (sinAlcance()) {
            <!-- Sin empresa/proveedor no hay consulta: «Sin resultados» engañaría. -->
            <p class="gs__hint">{{ t('BUSQUEDA.SIN_EMPRESA') }}</p>
          } @else if (cargando()) {
            <div class="gs__section">
              @for (row of skeletonRows; track row) {
                <div class="gs__item gs__item--skeleton">
                  <span class="gs__sk gs__sk--icon"></span>
                  <span class="gs__item-body">
                    <span class="gs__sk gs__sk--title"></span>
                    <span class="gs__sk gs__sk--sub"></span>
                  </span>
                </div>
              }
            </div>
          } @else if (error()) {
            <p class="gs__hint gs__hint--error">{{ error() }}</p>
          } @else if (sinResultados()) {
            <p class="gs__hint">
              {{ t('BUSQUEDA.EMPTY', { query: query() }) }}
            </p>
          } @else {
            @for (grupo of grupos(); track grupo.tipo) {
              <div class="gs__section">
                <div class="gs__section-head">
                  <span class="gs__section-title">{{
                    t('BUSQUEDA.GROUPS.' + grupo.tipo)
                  }}</span>
                  <span class="gs__section-count">{{ grupo.total }}</span>
                </div>

                @for (r of grupo.items; track keyResultado(r)) {
                  <button
                    type="button"
                    role="option"
                    class="gs__item"
                    [class.gs__item--active]="activeKey() === keyResultado(r)"
                    [attr.aria-selected]="activeKey() === keyResultado(r)"
                    (click)="onClickResultado(r, $event)"
                    (auxclick)="onAuxClickResultado(r, $event)"
                  >
                    <span class="gs__item-icon">
                      <app-ui-icon [name]="ICONO_TIPO[r.tipo]" [size]="18" />
                    </span>

                    <span class="gs__item-body">
                      <span class="gs__item-title">{{ r.numero }}</span>

                      <span class="gs__item-sub">
                        @if (r.cliente) {
                          <span>{{ r.cliente }}</span>
                        }
                        @if (r.fase) {
                          <span class="gs__dot">·</span>
                          <span>{{ r.fase }}</span>
                        }
                      </span>

                      <!--
                        Cuando la fila se encontró por un identificador ajeno a su
                        número (BL, factura comercial…), decirlo. Sin esto el
                        resultado parece un fallo del buscador.
                      -->
                      @if (r.coincidenciaIndirecta && r.valorCoincidencia) {
                        <span class="gs__match">
                          {{
                            t('BUSQUEDA.MATCH.' + r.motivo, {
                              valor: r.valorCoincidencia,
                            })
                          }}
                        </span>
                      }
                    </span>

                    <span
                      class="gs__state"
                      [class.gs__state--closed]="!r.abierto"
                    >
                      {{
                        r.abierto
                          ? t('BUSQUEDA.STATE.OPEN')
                          : t('BUSQUEDA.STATE.CLOSED')
                      }}
                    </span>
                  </button>
                }
              </div>
            }
          }
        }

        <footer class="gs__foot">
          <span class="gs__combo">
            <app-kbd>↑</app-kbd><app-kbd>↓</app-kbd>
            {{ t('BUSQUEDA.KEYS.NAVIGATE') }}
          </span>
          <span class="gs__combo">
            <app-kbd>↵</app-kbd> {{ t('BUSQUEDA.KEYS.SELECT') }}
          </span>
          <span class="gs__combo">
            <app-kbd>Esc</app-kbd> {{ t('BUSQUEDA.KEYS.CLOSE') }}
          </span>
        </footer>
      </div>
    }
  </div>
</ng-container>
